import React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  PaymentLinkSideBarContainer,
  ImageCon,
  SideBarContent,
  MainMenuText,
  LogOutText,
  Span,
  XIcon,
  FipayLogo,
  FipayMobileLogo,
  CloseButton,
  SpanHead,
  SpanBottom,
} from "./Sidebar.styles";
import { useDispatch } from "react-redux";
import { clearStorage } from "../../../store";
import { ROUTES } from "./Routes";

interface CloseButtonProps {
  icon: string;
  onClick: () => void;
}

const PaymentLinkSidebar = ({
  closeButton,
}: {
  closeButton?: CloseButtonProps;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname: currentRoute } = useLocation();

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const handleLogout = () => {
    dispatch(clearStorage());
    window.location.href = ROUTES.LOGIN;
  };

  const navItems = [
    {
      key: "home",
      label: "Home",
      icon:
        currentRoute === ROUTES.HOME
          ? "/assets/svg/Home_Green.svg"
          : "/assets/home.png",
      path: ROUTES.HOME,
    },
    {
      key: "paymentLink",
      label: "Payment Link",
      icon:
        currentRoute === ROUTES.PAYMENT_LINK
          ? "/assets/moneys.png"
          : "/assets/svg/money_White.svg",
      path: ROUTES.PAYMENT_LINK,
    },
    {
      key: "transaction",
      label: "Transactions",
      icon:
        currentRoute === ROUTES.TRANSACTION
          ? "/assets/svg/TransactionIcon_Green.svg"
          : "/assets/TransactionIcon.png",
      path: ROUTES.TRANSACTION,
    },
    {
      key: "tokenization",
      label: "Token",
      icon:
        currentRoute === ROUTES.TOKENIZATION
          ? "/assets/svg/money_Green.svg"
          : "/assets/svg/money_White.svg",
      path: ROUTES.TOKENIZATION,
    },
    {
      key: "settings",
      label: "Settings",
      icon: "/assets/setting.png",
      path: ROUTES.SETTINGS,
    },
  ];

  return (
    <PaymentLinkSideBarContainer>
      <ImageCon>
        <Link to="/">
          <FipayLogo src="/assets/icons/fipay.svg" alt="fipaylogo" />
        </Link>
        <Link to="/">
          <FipayMobileLogo
            src="/assets/icons/fipay-mobile.svg"
            alt="fipaylogo"
          />
        </Link>
      </ImageCon>

      {closeButton && (
        <CloseButton onClick={closeButton.onClick}>
          <XIcon src={closeButton.icon} alt="close-icon" />
        </CloseButton>
      )}

      <MainMenuText>
        <SpanHead>MAIN MENU</SpanHead>
      </MainMenuText>

      <div>
        {navItems.map(({ key, label, icon, path }) => (
          <SideBarContent
            key={key}
            active={currentRoute === path}
            currentRoute={currentRoute}
            onClick={() => handleNavigation(path)}
          >
            <img src={icon} alt={label} />
            <Span>{label}</Span>
          </SideBarContent>
        ))}
      </div>

      <LogOutText onClick={handleLogout}>
        <img src="/assets/logout.png" alt="logout" />
        <SpanBottom>Log Out</SpanBottom>
      </LogOutText>
    </PaymentLinkSideBarContainer>
  );
};

export default PaymentLinkSidebar;
